import { useNavigate } from 'react-router-dom';

export const useAccountNavigation = (accountNo?: string) => {
    const navigate = useNavigate();

    const navigateToAccount = () => {
        if (accountNo) {
            navigate('/wallet/accountManagement');
        } else {
            navigate('/wallet/accountVerification');
        }
    };

    return navigateToAccount; // 객체가 아닌 함수 직접 반환
};